import styled from '@emotion/styled';

import { Icon, type IconName } from '@travelnest/hui';

import { colors, font } from '@/lib/theme';

const Row = styled.li`
	display: flex;
	align-items: center;
	gap: 12px;
	${font('IR100')}
	color: ${colors.typography.body};
	list-style: none;
`;

const IconBox = styled.span`
	display: flex;
	flex: 0 0 24px;

	svg {
		color: ${colors.LM_NU70};
	}
`;

interface IconLabelProps {
	icon: IconName;
	label: string;
}

/** One line of a feature list: an icon and its label (amenities, house rules). */
export const IconLabel = ({ icon, label }: IconLabelProps) => (
	<Row>
		<IconBox>
			<Icon name={icon} size={24} />
		</IconBox>
		<span>{label}</span>
	</Row>
);

/** Lays `IconLabel`s out in two columns. */
export const IconLabelList = styled.ul`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px 24px;
	padding: 0;
	margin: 0;
`;
